export default ".video-container {\n  height: 270px;\n  justify-content: center;\n}\n\n.video-player {\n  height: 100%;\n}";